if (!customElements.get("custom-swiper")) {
  customElements.define("custom-swiper", class CustomSwiper extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("swipeTo", (e) => this.swipeTo(e.detail?.index));
    }

    getSlideAxis() {
      const attrAxis = window.theme?.methods?.nestedScroll?.normalizeAxis?.(this.getAttribute("data-scroll-axis"));
      if (attrAxis) return attrAxis;

      const direction = this.swiper?.params?.direction || this.config?.direction || "horizontal";
      return direction === "vertical" ? "y" : "x";
    }

    shouldUseNestedScroll() {
      return !!this.parentElement?.closest("[data-scroll-axis], [data-drawer-scrolls]");
    }

    init() {
      if (this.swiper) return;

      this.swiperContainer = this.querySelector(".swiper");
      if (!this.swiperContainer) return;

      if (this.dataset.config) {
        this.config = JSON.parse(this.dataset.config);
      }

      this.prev = this.querySelector("[data-swiper-prev-button]");
      this.next = this.querySelector("[data-swiper-next-button]");
      this.scrollbar = this.querySelector("[data-scrollbar]");
      this.isPauseOnMounseenter = this.hasAttribute("data-pause-onmouseenter");
      this.pagination = this.querySelector("[data-pagination]");

      const config = {
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        ...this.config
      };
      if (this.prev && this.next) {
        config.navigation = {
          prevEl: this.prev,
          nextEl: this.next
        };
      }
      if (this.scrollbar) {
        config.scrollbar = {
          el: this.scrollbar
        };
      }
      if (this.pagination) {
        config.pagination = {
          el: this.pagination
        };
      }

      if (!this.hasAttribute("data-scroll-axis")) {
        this.setAttribute("data-scroll-axis", this.getSlideAxis());
      }

      if (this.shouldUseNestedScroll()) {
        // 嵌套滚动时需关闭 touchStartPreventDefault，好让外层竖滑与内层横滑协作；
        // 仅 coarse pointer（触摸）才关。PC 鼠标保持默认 true，避免拖 <a>/img 变成浏览器原生链接拖拽。
        if (window.matchMedia("(pointer: coarse)").matches) {
          config.touchStartPreventDefault = false;
        }
        if (config.threshold === undefined) config.threshold = 5;
      }

      this.swiper = new Swiper(this.swiperContainer, config);

      if (this.shouldUseNestedScroll()) {
        window.theme?.methods?.nestedScroll?.unbind?.(this);
        window.theme?.methods?.nestedScroll?.bindSwipe?.(this.swiper, this, {
          axis: this.getSlideAxis(),
          touchTarget: this.swiperContainer,
        });
      }

      if (this.isPauseOnMounseenter) {
        this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
        this.addEventListener("mouseleave", this.onMouseOut.bind(this));
      }
    }

    swipeTo(index) {
      if (this.swiper && index != null) {
        this.swiper.slideTo(index);
      }
    }

    onMouseEnter() {
      // this.swiper.autoplay.stop();
    }

    onMouseOut() {
      // this.swiper.autoplay.start();
    }

    connectedCallback() {
      this.observeElement(this, this.handleInViewport.bind(this));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.theme?.methods?.nestedScroll?.unbind?.(this);
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }

    handleInViewport() {
      this.init();
    }

    observeElement(element, callback) {
      const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            callback();
            observerInstance.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        threshold: 0.5
      });
      if (this.isElementInViewport(element)) {
        callback();
        return;
      }
      observer.observe(element);
      this.observer = observer;
    }

    isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0;
    }
  });
}
